import { buildSlice, CommonState } from '~libs/reduxUtils';

import { Lookup } from '~lookups/models';

import { clientFormOptionsApi } from '~lookups/actions/clientFormOptions';

export const typePrefix = 'client-form-options';

const initialState: CommonState<Lookup> = {
  loading: 'idle',
  error: null,
  rows: [],
};

const slice = buildSlice<CommonState<Lookup>, Lookup>(typePrefix, initialState, {
  rtkQueryBridges: [
    {
      endpoint: clientFormOptionsApi.endpoints.getClientFormOptions,
      mode: 'list',
      apply: (state, payload) => {
        state.rows = payload as Lookup[];
      },
    },
  ],
});

export default slice.reducer;
